export const customerUrl = 'https://www.peoplesstore.ng';
export const vendorUrl = 'https://vendor.peoplesstore.ng';
